import { ContentWrapper } from '@/components/_common';
import StatusTag from '@/components/_common/StatusTag';
import {
  workorderComplementColor,
  WorkOrderComplementStatus,
} from '@/core/domain/workorder/WorkOrdersComplements/WorkOrdersComplements.types';
import { useWindowSize } from '@/hooks';
import { Col, Divider, Row } from 'antd';
import WorkOrdersAuthorizedMonth from './WorkOrdersAuthorizedMonth';
import WorkOrdersAuthorizedTotal from './WorkOrdersAuthorizedTotal';

interface Props {
  workOrderValueAuthorizedMonth?: number;
  workOrderValueTotal?: number;
}

function WorkOrderAuthorized({
  workOrderValueAuthorizedMonth,
  workOrderValueTotal,
}: Props) {
  const { width } = useWindowSize();

  return (
    <ContentWrapper
      style={{ padding: '16px' }}
      extraStyle={{ top: '10px', right: '8px' }}
    >
      <StatusTag
        size="lg"
        label={'Autorizado'}
        color={workorderComplementColor[WorkOrderComplementStatus.Authorized]}
      />

      <Row gutter={[24, 12]} style={{ marginTop: 8 }}>
        <Col span={width < 1707 ? 24 : undefined}>
          <WorkOrdersAuthorizedMonth
            value={workOrderValueAuthorizedMonth || 0}
          />
        </Col>

        <Col span={width < 1707 ? 24 : undefined}>
          <Divider
            type={width >= 1707 ? 'vertical' : 'horizontal'}
            style={{ height: '100%', margin: 0 }}
          />
        </Col>

        <Col span={width < 1707 ? 24 : undefined}>
          <WorkOrdersAuthorizedTotal value={workOrderValueTotal || 0} />
        </Col>
      </Row>
    </ContentWrapper>
  );
}

export default WorkOrderAuthorized;
